module.exports = new __parcel__URL__("cellar-door.b0bd5091.webp").toString();